import { Input, InputTypes } from '@leegality/leegality-react-component-library';
import { useTranslation } from '@utils';
import FieldLabel from '@components/form/field-label';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

const FollowUpQuestionField = ({
  index, question, mandatory, value, onChange,
}) => {
  const getTranslation = useTranslation();
  const handleChange = useCallback((e) => onChange(index, e.target.value), [onChange, index]);

  return (
    <div>
      <div className="mb-1.5">
        <FieldLabel name={question} mandatory={mandatory} className="break-words" />
      </div>
      <Input
        type={InputTypes.TEXT}
        value={value}
        placeholder={getTranslation('FEEDBACK_ANSWER_PLACEHOLDER')}
        onChange={handleChange}
      />
    </div>
  );
};

FollowUpQuestionField.propTypes = {
  index: PropTypes.number.isRequired,
  question: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

FollowUpQuestionField.defaultProps = {
  mandatory: false,
  value: '',
};

export default memo(FollowUpQuestionField);
